var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 88,
    viewBox: "0 0 82 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    d: "M40.8286 0C18.4542 0 0.289062 19.7157 0.289062 44C0.289062 68.2843 18.4542 88 40.8286 88C63.2031 88 81.3682 68.2843 81.3682 44C81.3682 19.7157 63.2031 0 40.8286 0ZM40.8286 2.75C50.5277 2.75 59.3485 6.71733 66.0612 13.2H15.5928C22.5332 6.46465 31.5185 2.74393 40.8286 2.75ZM16.5522 15.95H65.1051L40.8286 68.651L16.5522 15.95ZM12.4509 16.61V71.39C6.2453 63.8571 2.81719 54.1049 2.82279 44C2.82279 33.4767 6.47811 23.903 12.4509 16.6173V16.61ZM69.2064 16.61C75.412 24.1429 78.8401 33.8951 78.8345 44C78.8345 54.527 75.1792 64.1007 69.2064 71.3863V16.61ZM14.9847 18.7L39.5618 72.05H14.9847V18.7ZM66.6726 18.7V72.05H42.0955L66.676 18.7H66.6726ZM15.6029 74.8H66.0612C59.1216 81.5345 50.1377 85.2552 40.8286 85.25C31.5208 85.2543 22.5382 81.5337 15.5995 74.8H15.6029Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.e1284c3e99b545a7d51f1ec6fe42e720.svg";
export { ForwardRef as ReactComponent };